import React from "react";
import {
  Container,
  PrivacyTitle,
  Paragarph,
  ParagarphContainer,
  Button,
  ButtonContainer,
  Link,
} from "./privacyPolicy.styles";
import Title from "../Title/Title";

const PrivacyPolicy = ({ setPrivacyShow }) => {
  return (
    <Container>
      <Title />
      <ParagarphContainer>
        <PrivacyTitle dir="auto">כמה מילים על פרטיות</PrivacyTitle>
        <Paragarph dir="auto">
          הפרטיות שלך חשובה לנו, לכן לעולם לא נבקש ממך מידע מזהה על עצמך או על
          אדם אחר.
        </Paragarph>
        <Link
          onClick={() =>
            window.open(
              "https://kayma.com/terms_and_conditions/ynet_widget_privacy_policy/"
            )
          }
        >
          לקריאת מדיניות הפרטיות המלאה
        </Link>
        <ButtonContainer>
          <Button onClick={() => setPrivacyShow(false)}>אוקיי, הבנתי</Button>
        </ButtonContainer>
      </ParagarphContainer>
    </Container>
  );
};

export default PrivacyPolicy;
